<template>
  <div>
    <l-geo-json
        ref="refugios"
        :geojson="geometrias"
        :options="optRefugios"
        @ready="cargado"
    ></l-geo-json>
  </div>
</template>

<script>
import {LGeoJson} from 'vue2-leaflet';
import {icon, marker} from "leaflet";

export default {
  name: "Refugios",
  props: ['geojson', 'visibles'],
  data() {
    return {
      optRefugios: {
        pointToLayer: this.crearRefugio,
        onEachFeature: this.clickRefugio
      },
      iconoRefugio: icon({
        iconUrl: require('@/assets/iconos/refugio.svg'),
        iconSize: [24, 24],
        iconAnchor: [12, 12]
      }),
      geometrias: null
    }
  },
  created() {
    this.geometrias = Object.assign({}, this.geojson)
  },
  methods: {
    crearRefugio(feature, latlng) {

      if(this.visibles.includes(feature.properties.id)) {
        return marker(latlng, {
          icon: this.iconoRefugio,
          opacity: 1
        }).bindPopup('<p><strong>'+feature.properties.name+'</strong></p>');
      }
    },
    clickRefugio(feature, layer) {
      layer.on({
        click: () => this.$emit('refugioSeleccionado', { refugio: feature.properties, capa:layer})
      })
    },
    cargado() {
      this.$emit('refugiosCargados');
    }
  },
  components: {
    LGeoJson
  }
}
</script>

<style scoped>

</style>